import React from 'react'
import './LoadingScreen.css'

interface LoadingScreenProps {
  message?: string
  detail?: string
  overlay?: boolean
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = 'Preparando tu espacio de trabajo',
  detail = 'Conectando con Microsoft 365…',
  overlay = false,
}) => {
  return (
    <div
      className={`loadingScreen ${overlay ? 'loadingScreen--overlay' : ''}`}
      data-sales-boot-state="loading"
      role="status"
      aria-live="polite"
    >
      <div className="loadingScreen__panel">
        <div className="loadingScreen__app">Wacner Sales</div>
        <h1 className="loadingScreen__title">{message}</h1>
        <p className="loadingScreen__detail">{detail}</p>
        <div className="loadingScreen__bar" aria-hidden="true" />
      </div>
    </div>
  )
}
